import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=5199b8f9&scoped=true"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"
import style0 from "./Threads.vue?vue&type=style&index=0&id=5199b8f9&prod&lang=scss&scoped=true"
import style1 from "./Threads.vue?vue&type=style&index=1&id=5199b8f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199b8f9",
  null
  
)

export default component.exports